const DAYS = [
  { day: "Sunday", abbr: "Su" },
  { day: "Monday", abbr: "Mo" },
  { day: "Tuesday", abbr: "Tu" },
  { day: "Wednesday", abbr: "We" },
  { day: "Thursday", abbr: "Th" },
  { day: "Friday", abbr: "Fr" },
  { day: "Saturday", abbr: "Sa" }
];

const MONTHS = [
  { month: "January", abbr: "Jan" },
  { month: "February", abbr: "Feb" },
  { month: "March", abbr: "Mar" },
  { month: "April", abbr: "Apr" },
  { month: "May", abbr: "May" },
  { month: "June", abbr: "Jun" },
  { month: "July", abbr: "Jul" },
  { month: "August", abbr: "Aug" },
  { month: "September", abbr: "Sep" },
  { month: "October", abbr: "Oct" },
  { month: "November", abbr: "Nov" },
  { month: "December", abbr: "Dec" }
];

export { DAYS, MONTHS };
